import { QuickShopCarouselProps } from "@bluebottlecoffee/design-system/components";
import { toHTML } from "@portabletext/to-html";
import { ShopCardPropsWithSlug, toShopCardProps } from "./shop-card";
import { ShippingCopy } from "../sanity-schema";
import { DereferencedQuickShopCarouselProps } from "../../components/QuickShopCarouselWrapper";
import { toLinkProps } from "./link";
import { ConversionCopy } from "../../pages/[region]/[lang]/product/[slug]";
import { trackEvent } from "../segment/track-event";
import { isHomePage, stripHtmlTags } from "../utils";

export type QuickShopCarouselTransformerProps = Omit<
  QuickShopCarouselProps,
  "shopCards"
> & {
  shopCards: ShopCardPropsWithSlug[];
};

export function toQuickShopCarouselProps(
  shopcardCopy: {
    copy: ConversionCopy;
    shippingCopy: ShippingCopy;
  },
  data: DereferencedQuickShopCarouselProps,
  lang: string,
  region: string,
): QuickShopCarouselTransformerProps {
  const { shopCards: products } = data;
  const shopCardsForSale = products.filter((product) => product.forSale);
  if (shopCardsForSale.length < 3) {
    throw Error(
      "QuickShopCarousel must have at least 3 products that are for sale.",
    );
  }

  const shopCards = shopCardsForSale.map((shopCard) =>
    toShopCardProps({
      data: shopCard,
      lang,
      region,
      ...shopcardCopy,
    }),
  );

  const heading = toHTML(data.heading[lang]);

  return {
    bgColor: data.bgColor ?? undefined,
    heading,
    shopCards,
    cta: data.cta?.text && {
      ...toLinkProps(data.cta, region, lang),
      onClick: () => {
        if (isHomePage(lang, region)) {
          trackEvent("homepage_cta", {
            heading: stripHtmlTags(heading),
            cta_name: data.cta?.text[lang],
          });
        }
      },
    },
  };
}
